import { inject } from '@angular/core';
import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';
import { AnalyticsService } from './analytics.service';

/** Registers Core Web Vitals listeners and forwards metrics to PostHog. */
export function reportWebVitals(): () => void {
  return () => {
    const analytics = inject(AnalyticsService);

    const reportMetric = (metric: Metric): void => {
      analytics.capture('web_vital', {
        name: metric.name,
        rating: metric.rating,
        value: metric.value,
      });
    };

    onCLS(reportMetric);
    onFCP(reportMetric);
    onINP(reportMetric);
    onLCP(reportMetric);
    onTTFB(reportMetric);
  };
}
